import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import productApi, { productType } from '@/services/productApi';

import type { RootState } from '../store';
import { setCoupon, setCurrency } from './paymentSlice';
import { queryPromotionActivity, type PromotionActivityType } from '@/services/paymenApi';
import { getCouponList } from './promoCodeSlice';
// Define a type for the slice state

interface CounterState {
  productPrice: productType[];
  activeCode: PromotionActivityType | null;
  activityError: boolean;
  isUpgrate: boolean;
}

// Define the initial state using that type
const initialState: CounterState = {
  productPrice: [],
  activeCode: null,
  activityError: false,
  isUpgrate: false,
};

// async;

export const getProductPrice = createAsyncThunk(
  'product/price',
  async (userData: { lang: string }, { rejectWithValue, dispatch, getState }) => {
    const { lang, ...fields } = userData;
    try {
      const response = await productApi.getProductprice(lang);
      const { errorCode } = response;

      if (errorCode === '0') {
        const state = getState() as RootState;
        if (!state.payment.currency) {
          dispatch(setCurrency(response.defaultCurrency));
        }
        const data = response.plans as productType[];
        return data;
      }

      throw new Error('');
    } catch (err: any) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  },
);
export const getPromotionActivity = createAsyncThunk(
  'product/activity',
  async (data: { couponCode: string }, { rejectWithValue, dispatch, getState }) => {
    try {
      const state = getState() as RootState;
      // 产品升级不显示活动
      if (state.product.isUpgrate) {
        dispatch(setCoupon(''));
        return null;
      }
      const response = await queryPromotionActivity(data);
      const { errorCode, sys_status, _sys_status, ...resData } = response;
      if (errorCode === '0') {
        const { isAvailable } = resData;
        // if activity coupon is unavailable
        if (!isAvailable) {
          const { URLQueryParams } = state.user;
          // if coupon from couponcode, using this coupon
          if (URLQueryParams?.coupon && URLQueryParams?.origin === 'promocode') {
            return null;
          } else {
            // the other situations, using user coupons by api getCouponList
            const currentCurrecy: string = state.payment.currency;
            dispatch(getCouponList(currentCurrecy));
          }
          return null;
        }
        const coupon = process.env.REACT_APP_ACTIVE_CODE;
        if (coupon) {
          dispatch(setCoupon(coupon));
        }
        return resData;
      } else {
        return null;
      }
    } catch (err: any) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  },
);

export const productSlice = createSlice({
  name: 'product',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setActivityError: (state, action: PayloadAction<boolean>) => {
      state.activityError = action.payload;
    },
    setIsUpgrate: (state, action: PayloadAction<boolean>) => {
      state.isUpgrate = action.payload;
    },
  },
  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder.addCase(getProductPrice.fulfilled, (state, action) => {
      // Add user to the state array
      state.productPrice = action.payload;
    });
    builder.addCase(getPromotionActivity.fulfilled, (state, action) => {
      // Add user to the state array
      state.activeCode = action.payload;
    });
  },
});

export const { setActivityError, setIsUpgrate } = productSlice.actions;

export default productSlice.reducer;
